import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProblemSolved from "@/components/ProblemSolved";
import WhoWeHelp from "@/components/WhoWeHelp";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import Referral from "@/components/Referral";
import Partners from "@/components/Partners";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import IntroReferralModal from "@/components/IntroReferralModal";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="font-body text-[var(--ew-text)]">
      <Navbar />
      <Hero />
      <ProblemSolved />
      <WhoWeHelp />
      <Services />
      <WhyChoose />
      <Referral />
      <Partners />
      <Contact />
      <Footer />
      <IntroReferralModal />
    </main>
  );
}
